module.exports = __webpack_public_path__ + "media/assets/images/webpage-icon-fc09fb742e358076539ffa2b3fb3dbe5.png";